export default {
  "nav.spreadsheet": "Arkusz",
  "nav.guides": "Poradniki",
  "nav.reviews": "Opinie",
  "nav.shipping": "Wysyłka",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.visit": "Odwiedź główną stronę",

  "hero.badge": "Niezależne centrum zasobów",
  "hero.title": "USFans Spreadsheet — Twój kompletny przewodnik po zakupach USFans",
  "hero.subtitle": "Szukasz arkusza USFans, poradnika zakupowego lub wiarygodnych informacji przed zakupem? Jesteś we właściwym miejscu. Przeglądaj uporządkowane zasoby, poradniki produktowe, informacje o wysyłce, wskazówki magazynowe, porady QC, opinie i poradniki bezpieczeństwa — wszystko w jednym łatwym w obsłudze centrum.",
  "hero.cta_primary": "Odkryj arkusz USFans",
  "hero.cta_secondary": "Przeczytaj poradnik USFans",
  "hero.trust": "Niezależne źródło · Aktualizowane poradniki · Praktyczne informacje · Nastawione na bezpieczeństwo",
  "hero.search_placeholder": "Szukaj poradników, wysyłki, QC, kuponów…",
  "hero.table_title": "Przykładowy układ arkusza",
  "hero.col_product": "Produkt",
  "hero.col_category": "Kategoria",
  "hero.col_reference": "Referencja",
  "hero.col_qc": "QC",
  "hero.col_shipping": "Wysyłka",
  "hero.col_status": "Status",
  "hero.item_1": "Pozycja 01",
  "hero.item_2": "Pozycja 02",
  "hero.item_3": "Pozycja 03",
  "hero.item_4": "Pozycja 04",
  "hero.qc_pending": "Oczekujący",
  "hero.qc_passed": "Zatwierdzony",
  "hero.ship_standard": "Standardowa",
  "hero.ship_express": "Ekspresowa",
  "hero.status_considering": "Rozważany",
  "hero.status_ordered": "Zamówiony",
  "hero.status_received": "Odebrany",

  "main.buy_now": "Kup teraz",
  "main.tagline": "Przeglądaj całą kolekcję na naszej głównej stronie",
  "main.note": "Wszystkie linki produktów otwierają się w nowej karcie na naszej głównej stronie.",

  "category.title": "Zakupy według kategorii",
  "category.subtitle": "Przejdź od razu do dowolnej kategorii produktów na głównej stronie.",
  "category.dropdown_label": "Wybierz kategorię",
  "category.dropdown_placeholder": "Wybierz kategorię, aby przejść",

  "what_is.title": "Czym jest arkusz USFans?",
  "what_is.body": "Arkusz USFans to uporządkowane źródło, które pomaga kupującym organizować i odkrywać informacje o produktach. Naszym celem jest ułatwienie zrozumienia tych informacji poprzez zebranie praktycznych poradników, zasobów produktowych, wyjaśnień dotyczących wysyłki, wskazówek QC i przydatnych referencji w jednym miejscu.",
  "what_is.cta": "Odkryj centrum arkusza",

  "features.title": "Wszystko, co musisz wiedzieć o USFans",
  "features.subtitle": "Zacznij tutaj, aby zrozumieć platformę przed zakupami.",
  "features.spreadsheet.title": "Arkusz USFans",
  "features.spreadsheet.desc": "Poznaj zasoby arkusza i dowiedz się, jak poruszać się po informacjach o produktach.",
  "features.review.title": "Opinia o USFans",
  "features.review.desc": "Zrozum platformę, proces zakupowy, potencjalne zalety i rzeczy, które warto rozważyć.",
  "features.shipping.title": "Koszt wysyłki USFans",
  "features.shipping.desc": "Dowiedz się, co może wpływać na koszty wysyłki i jak porównać dostępne opcje.",
  "features.coupon.title": "Kupon USFans",
  "features.coupon.desc": "Sprawdź, gdzie szukać aktualnych promocji i jak weryfikować informacje o zniżkach.",
  "features.warehouse.title": "Magazyn USFans",
  "features.warehouse.desc": "Zrozum proces magazynowy, przechowywanie, QC i przygotowanie wysyłki.",
  "features.legit.title": "Czy USFans jest legalny?",
  "features.legit.desc": "Przejrzyj praktyczne kontrole bezpieczeństwa i pytania, które warto rozważyć przed skorzystaniem z usługi.",

  "guides.title": "Zacznij od najpopularniejszych poradników",
  "guides.subtitle": "Starannie wybrane zasoby, które pomogą Ci robić zakupy pewnie.",
  "guides.card1": "Poradnik arkusza USFans",
  "guides.card2": "Opinia o USFans",
  "guides.card3": "Poradnik kosztów wysyłki USFans",
  "guides.card4": "Poradnik kuponów USFans",
  "guides.card5": "Poradnik magazynu USFans",
  "guides.card6": "Czy USFans jest legalny?",

  "why.title": "Dlaczego warto korzystać z tego źródła?",
  "why.subtitle": "Stworzone, aby ułatwić i zabezpieczyć Twoje badania zakupowe.",
  "why.1.title": "Uporządkowane informacje",
  "why.1.desc": "Wszystko pogrupowane w jedną przejrzystą, logiczną strukturę.",
  "why.2.title": "Przyjazne dla początkujących",
  "why.2.desc": "Wyjaśnienia prostym językiem na każdym poziomie.",
  "why.3.title": "Tabele porównawcze",
  "why.3.desc": "Zobacz opcje obok siebie przed podjęciem decyzji.",
  "why.4.title": "Aktualizowane treści",
  "why.4.desc": "Poradniki regularnie przeglądane i odświeżane.",
  "why.5.title": "Nastawione na bezpieczeństwo",
  "why.5.desc": "Praktyczne kontrole, które pomogą Ci kupować odpowiedzialnie.",
  "why.6.title": "Wielojęzyczne",
  "why.6.desc": "Dostępne po angielsku, polsku, hiszpańsku i francusku.",

  "compare.title": "Porównaj, zanim zdecydujesz",
  "compare.body": "Różne metody zakupów, opcje wysyłki i procesy mogą wiązać się z różnymi kosztami, wymaganiami i ryzykiem. Skorzystaj z naszych poradników porównawczych, aby zrozumieć różnice przed podjęciem decyzji.",
  "compare.cta": "Zobacz porównania USFans",

  "safety.title": "Bezpieczeństwo przede wszystkim",
  "safety.body": "Zakupy online wiążą się z ryzykiem. Zawsze weryfikuj aktualne informacje, dane płatności, zasady wysyłki i informacje o sprzedawcy przed dokonaniem zakupu.",
  "safety.cta": "Przeczytaj poradnik bezpieczeństwa USFans",

  "homeArticle.title": "Najnowszy poradnik",
  "homeArticle.subtitle": "Przeczytaj nasz szczegółowy poradnik dla początkujących o arkuszu USFans.",
  "homeArticle.cta": "Przeczytaj pełny poradnik",
  "homeArticle.read_time": "Czas czytania: 6 min",

  "faq.title": "Często zadawane pytania",
  "faq.q1": "Czym jest arkusz USFans?",
  "faq.a1": "Arkusz USFans to uporządkowane źródło, które pomaga kupującym organizować i odkrywać informacje o produktach w jednym miejscu.",
  "faq.q2": "Czy to jest oficjalna strona USFans?",
  "faq.a2": "Nie. To niezależna platforma informacyjna i zasobowa. Nie jesteśmy powiązani z żadnym konkretnym sprzedawcą ani przez niego popierani.",
  "faq.q3": "Jak przeglądać produkty?",
  "faq.a3": "Skorzystaj z menu kategorii lub przycisków powyżej, aby przejść bezpośrednio do dowolnej kategorii produktów na głównej stronie.",
  "faq.q4": "Czy publikujecie ceny lub kupony?",
  "faq.a4": "Dzielimy się wyłącznie ogólnymi wskazówkami. Zawsze weryfikuj aktualne ceny, promocje i szczegóły wysyłki bezpośrednio na głównej stronie.",

  "final.title": "Gotowy, aby odkryć zasoby arkusza USFans?",
  "final.body": "Zacznij od arkusza, porównaj opcje i poznaj podstawy, zanim dokonasz zakupu.",
  "final.cta_primary": "Odkryj arkusz USFans",
  "final.cta_secondary": "Odwiedź główną stronę",

  "footer.description": "Niezależne wielojęzyczne centrum zasobów o arkuszu USFans. Dzielimy się poradnikami, opiniami i praktycznymi informacjami zakupowymi, aby pomóc Ci podejmować świadome decyzje.",
  "footer.resources": "Zasoby",
  "footer.company": "Firma",
  "footer.legal": "Prawne",
  "footer.languages": "Języki",
  "footer.about": "O nas",
  "footer.editorial": "Polityka redakcyjna",
  "footer.contact": "Kontakt",
  "footer.disclaimer": "Zastrzeżenie",
  "footer.privacy": "Prywatność",
  "footer.terms": "Warunki",
  "footer.cookies": "Pliki cookie",
  "footer.disclaimer_text": "To niezależna strona informacyjna. Nie jesteśmy oficjalnym sklepem USFans i nie sprzedajemy produktów bezpośrednio. Wszystkie linki produktów prowadzą do głównej strony.",
  "footer.copyright": "© 2026 USFans Spreadsheet Resource Hub. Wszelkie prawa zastrzeżone.",
};